import { Dayjs } from "dayjs";
import { DateModel } from "../../../../shared/models/date.model";
import { OperatorList } from "../models/operatorList.model";

export interface OperatorComparingInitialState {
    operatorList: OperatorList[];
    companies: string[];
    departments: string[];
    operators: string[];
    dates: DateModel;
    showFilters: boolean;
    startDate: Dayjs | null;
    endDate: Dayjs | null;
}

const initialOperatorComparingState: OperatorComparingInitialState = {
    operatorList: [],
    companies: [],
    departments: [],
    operators: [],
    dates: {
        startDate: null,
        endDate: null
    },
    showFilters: true,
    startDate: null,
    endDate: null
}

export default initialOperatorComparingState